var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSentCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55 17.277a.83.83 0 01-.633-.256l-4.174-4.175a.7.7 0 01-.21-.534.754.754 0 01.225-.535.717.717 0 01.527-.217c.207 0 .382.072.527.217l3.739 3.738 8.638-8.638a.727.727 0 01.535-.217c.211 0 .39.072.534.217a.726.726 0 01.218.535c0 .211-.073.39-.218.534l-9.075 9.075a.829.829 0 01-.632.256z",
    fill: "#A3A3A3"
  })));
}
export default __webpack_public_path__ + "assets/static/media/mail-sent-check.f96b5b61.svg";
export { SvgMailSentCheck as ReactComponent };